import { Flex, LoadingSpin, PageContainer } from '@/components/common';
import { SurveyApiType } from '@/configs';
import { useSurvey } from '@/hooks';
import { Alert } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SurveysList from '../SurveysList';

export const Camp = () => {

  const [t] = useTranslation(['common', 'survey']);
  const { surveys, fetchSurvey, loading } = useSurvey();
  const type = SurveyApiType.Camps;

  useEffect(() => {
    fetchSurvey();
  }, []);

  const campSurveys = surveys?.filter((survey) => survey.type === type) ?? [];
  const hasCamp = campSurveys.length > 0;

  if (loading) {
    return <LoadingSpin fillHeight />;
  }

  if (!hasCamp) {
    return (
      <PageContainer title={t(`common:labels.survey-${type}`)}>
        <Alert type="warning" className="flex mx-auto max-h-16 mt-2 text-center" message={t(`common:messages.survey-empty-${type}`)} />
      </PageContainer>
    );
  }

  return (
    <PageContainer title={t(`common:labels.survey-${type}`)}>
      <Flex direction="column" className="max-w-xl mx-auto">
        <SurveysList
          surveys={campSurveys}
          onIgnore={() => { }}
          showIgnore={false}
          extraSpace
        />
      </Flex>
    </PageContainer>
  );
};

export default Camp;
